// Shared helpers for reading session source-summary fields and formatting counts.
import type { AppSession } from './api'

export function readNumber(value: number | undefined | null): number {
  return typeof value === 'number' && Number.isFinite(value) ? value : 0
}

export function sessionChangedFiles(session: AppSession): number {
  return readNumber(session.source_summary?.changedFileCount ?? null)
}

export function sessionHasUnsavedChanges(session: AppSession): boolean {
  return Boolean(session.source_summary?.hasUnsavedChanges ?? false)
}

export function sessionSavedChanges(session: AppSession): number {
  return readNumber(session.source_summary?.savedChangeCount ?? null)
}

export function sessionChangesApplied(session: AppSession): boolean {
  return Boolean(session.source_summary?.broughtBack ?? true)
}

export function pluralize(count: number, singular: string, plural = `${singular}s`): string {
  return `${count} ${count === 1 ? singular : plural}`
}
